module.exports = __webpack_public_path__ + "img/matrix.bf153f88.png";